import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import DeveloperAPI from "../components/DeveloperAPI";
import ProductShowcase from "../components/ProductShowcase";
import Partners from "../components/Partners";
import WhyChoose from "../components/WhyChoose";
import Industries from "../components/Industries";
import Onboarding from "../components/Onboarding";
import ContactCTA from "../components/ContactCTA";
import FAQ from "../components/FAQ";
import Blog from "../components/Blog";
import Certifications from "../components/Certifications";
import Footer from "../components/Footer";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;
    let tries = 0;
    // Wait for the async services section to mount so the target position is final
    const t = setInterval(() => {
      const el = document.querySelector(location.hash);
      const ready = document.querySelector('[data-testid="services-grid"]') || tries > 15;
      if (el && ready) {
        clearInterval(t);
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
      tries += 1;
      if (tries > 25) clearInterval(t);
    }, 200);
    return () => clearInterval(t);
  }, [location]);

  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <About />
        <DeveloperAPI />
        <ProductShowcase />
        <Partners />
        <WhyChoose />
        <Industries />
        <Onboarding />
        <ContactCTA />
        <FAQ />
        <Blog />
        <Certifications />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
